









































































































import moment from "moment";
import Vue from "vue";

// Vue components
import ColumnVisibilityFilter from "@/components/DataTableColumnVisibilityFilter/ColumnVisibilityFilter.vue";
import TableFiltersRow from "@/components/TableHeaderFilters/TableFiltersRow.vue";

import { GetI18nStringFromUserEventType, GetIconFromUserEventType, UserEventTypeEnum } from "@/model/data/enums/UserEventTypeEnum";
import { dataTableItemsPerPage } from "@/utility/Constants";
import { mapGetters, mapState } from "vuex";

import { CReqExecutionResultEnumToI18n } from "@/model/communication/CReqExecutionResultEnum";
import { RootState } from "@/store";
import { formatMilliseconds } from "@/utility/Formatter";
import UserEventInfoDialog from "./UserEventInfoDialog.vue";

export default Vue.extend({
    components: {
        TableFiltersRow,
        ColumnVisibilityFilter,
        UserEventInfoDialog,
    },
    props: {
        loading: { required: true, type: Boolean },
        paginatedTotalItems: Number,
        events: { required: true, type: Array },
    },
    data() {
        return {
            showInfoDialog: false,
            currentEvent: null,
            dataTableItemsPerPage,
            moment,
            prevIcon: "fas fa-chevron-left",
            nextIcon: "fas fa-chevron-right",
            ignoreOptionsChanges: false,
            ignoreDataChanges: false,
            options: {},
            availableHeaders: [],
            UserEventTypeEnum,
            sortBy: "Timestamp",
            sortDesc: true,
        };
    },
    watch: {
        options: {
            handler(newOptions, oldOptions) {
                if (oldOptions != null) {
                    if (newOptions.page < oldOptions.page) this.prevIcon = "fas fa-circle-notch fa-spin";
                    if (newOptions.page > oldOptions.page) this.nextIcon = "fas fa-circle-notch fa-spin";
                }
                if (newOptions != oldOptions) {
                    if (!this.ignoreOptionsChanges) this.$emit("send-request", newOptions);
                    else this.ignoreOptionsChanges = false;
                }
            },
            deep: true,
        },
        loading(newVal) {
            if (!newVal) {
                this.prevIcon = "fas fa-chevron-left";
                this.nextIcon = "fas fa-chevron-right";
            }
        },
    },
    computed: {
        ...mapGetters(["longDateFormat", "isUserSuperAdmin"]),
        ...mapState({
            isCloud: (state: RootState) => state.application.isCloud,
        }),
        initialAvailableHeaders() {
            let initialAvailableHeaders: any = [
                {
                    enabled: true,
                    canBeHidden: false,
                    value: "eventIcon",
                    width: "50px",
                },
                {
                    enabled: true,
                    canBeHidden: true,
                    text: this.$t("user_events.userEventType"),
                    value: "eventType",
                },
                {
                    enabled: true,
                    canBeHidden: true,
                    text: this.$t("common.timestamp"),
                    value: "timestamp",
                },
                {
                    enabled: true,
                    canBeHidden: true,
                    text: this.$t("user_events.executorUsername"),
                    value: "executorUsername",
                },
                {
                    enabled: true,
                    text: this.$t("user_events.involvedUser"),
                    value: "involvedUser",
                    sortable: false,
                },
            ];
            if (this.isCloud && this.isUserSuperAdmin)
                initialAvailableHeaders.push({
                    enabled: true,
                    text: this.$t("user_events.executionTime"),
                    value: "executionTime",
                });
            initialAvailableHeaders.push({
                enabled: true,
                text: this.$t("user_events.involvedInstallations"),
                value: "involvedInstallations",
                sortable: false,
                width: "30%",
            });
            initialAvailableHeaders.push({
                enabled: true,
                text: this.$t("user_events.response"),
                value: "response",
            });
            initialAvailableHeaders.push({
                enabled: true,
                text: this.$t("common.actions"),
                value: "actions",
                canBeHidden: false,
            });
            return initialAvailableHeaders;
        },
    },
    methods: {
        GetIconFromUserEventType,
        GetI18nStringFromUserEventType,
        formatMilliseconds,
        CReqExecutionResultEnumToI18n,
        backToTheFirst() {
            if (this.options.page != 1) {
                this.ignoreOptionsChanges = true;
                this.options.page = 1;
            }
        },
        showEventInfoDialog(event) {
            this.showInfoDialog = true;
            this.currentEvent = event;
        },
    },
});
